// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
// Import pages
import Home from './pages/Home';

// Removed pages: Refills, Transfer
import AboutUs from './pages/AboutUs';
import Contactus from './pages/ContactUs';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
// Removed pages: Halloween, Thanksgiving, Welcome, eRxInsCard, Christmas
import Topbar from './components/Topbar';
// Removed pages: PrescriptionFulfillment, FreeHomeDelivery, RefillMadeEasy, OverTheCounter, Vaccination
import Services from './pages/Services';
import HazardousWaste from './pages/HazardousWaste';
import MedicalWaste from './pages/MedicalWaste';
import ChemicalWaste from './pages/ChemicalWaste';
import CompliantHazardousWaste from './pages/CompliantHazardousWaste';
import Autoclave from './pages/Autoclave';
import LaundryService from './pages/LaundryService';
import Manufacturing from './pages/Manufacturing';
import './App.css';
import LiquidWaste from './pages/LiquidWaste';
import NonHazardousWaste from './pages/NonHazardousWaste';
import IndustrialWaste from './pages/IndustrialWaste';
import OrganicWaste from './pages/OrganicWaste';
import OtherWaste from './pages/OtherWaste';

function App() {
  return (
    <Router>
      <div className="d-flex flex-column min-vh-100">
        <Topbar />
         <div className="body-offset">
        <Header />
</div>
        <main className="flex-fill">
          <Routes>
            <Route path="/" element={<Home />} />
            
            {/* removed free-home-delivery and over-the-counter pages */}
            {/* removed health-product, refills and transfer pages */}
            <Route path="/about" element={<AboutUs />} />
             <Route path="/services" element={<Services />} />
            {/* removed refill-made-easy and prescription-fulfillment routes */}
            <Route path="/services/hazardous-waste" element={<HazardousWaste />} />
            <Route path="/services/compliant-hazardous-waste" element={<CompliantHazardousWaste />} />
            <Route path="/services/autoclave" element={<Autoclave />} />
            <Route path="/services/laundry-service" element={<LaundryService />} />
            <Route path="/services/manufacturing" element={<Manufacturing />} />
            <Route path="/services/medical-waste" element={<MedicalWaste />} />
            <Route path="/services/liquid-waste" element={<LiquidWaste />} />
            <Route path="/services/chemical-waste" element={<ChemicalWaste />} />
            <Route path="/services/non-hazardous-waste" element={<NonHazardousWaste />} />
            <Route path="/services/industrial-waste" element={<IndustrialWaste />} />
            <Route path="/services/organic-waste" element={<OrganicWaste />} />
            <Route path="/services/other-waste" element={<OtherWaste />} />
            <Route path="/contact" element={<Contactus />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
              {/* removed vaccinations route */}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            {/* removed halloween, thanksgiving, welcome, erx-ins-card, christmas pages */}
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
